module.exports = __webpack_public_path__ + "media/images/countrysquared/ph-5954ba97d21161a70958a8369b433b91.svg";